import { useModalView } from "components/ModalView";
import { StepProgress } from "components/Progress/StepProgress";

const ProgressIndicator = () => {
  const { maxViews, currentView } = useModalView();

  return <StepProgress my="34px !important" value={currentView + 1} max={maxViews} />;
};

export default ProgressIndicator;
